/**
 * Contact-note type constants.
 *
 * Complete `note_type` value set (contact_notes.note_type; mirrored by codegen
 * `Note_Type`). Use `z.enum(NOTE_TYPE_VALUES)` for note forms/inputs — never a
 * hand-typed literal. `satisfies readonly Note_Type[]` breaks `tsc` if the DB
 * enum drifts after codegen. NB: `follow_up` is NOT a note_type value — a note
 * form that offered it produced a DB enum-reject on save.
 *
 * This is the `contact_notes` note_type only. `task_notes.note_type`
 * (general/internal/client) is a SEPARATE, non-enum column — do not use this there.
 */

import type { Note_Type } from "@/src/gql/graphql";

export const NOTE_TYPE_VALUES = [
  "general",
  "call",
  "email",
  "meeting",
  "proposal",
  "internal",
] as const satisfies readonly Note_Type[];
